import * as React from 'react';
import { Link } from 'react-router-dom';
import { NavItemButton } from './NavItemButton';

export interface NavItemProps {
  path: string;
  name: string;
  onClick?: (e?: any) => void;
}

export const NavItem = ({ path, name, children, onClick }: React.PropsWithChildren<NavItemProps>) => (
  <Link data-testid={`${name}Link`} to={path} className='hover:no-underline h-full' onClick={onClick}>
    <NavItemButton path={path}>{children}</NavItemButton>
  </Link>
);
